export default "__VITE_ASSET__BjVGWzns__"